<script>
    import PlayerSummary from './PlayerSummary.svelte';
    export let player;
    export let league = "nba";
    export let proj_id;
    export let premium_membership = true;
    export let placeholder_variances;
</script>
<div class="modal fade" id="player-modal" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-body p-0">
            {#if player}
            <PlayerSummary placeholder_variances={placeholder_variances} premium_membership={premium_membership} player={player} league={league} proj_id={proj_id}></PlayerSummary>
            {/if}
        </div>
        <div class="modal-footer">
			<div class="btn-group" role="group">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
			</div>
        </div>
      </div>
    </div>
</div>